// // Function to get the redirect URI dynamically based on current location
// const getRedirectUri = () => {
//   if (typeof window === "undefined") {
//     // Server-side rendering fallback
//     return process.env.NODE_ENV === "production"
//       ? "https://securechatai.com/frontend/home"
//       : "http://localhost:3000/frontend/home";
//   }

//   // Get current origin and pathname
//   const origin = window.location.origin;
//   const pathname = window.location.pathname;

//   // If we're on a chatbot page, use that path; otherwise use /frontend/home
//   if (pathname.includes("/chatbot/")) {
//     return `${origin}${pathname}`;
//   }

//   // Default to /frontend/home
//   return `${origin}/frontend/home`;
// };

// export const ONEDRIVE_CONFIG = {
//   APPLICATION_ID: "20f96458-a442-4e5e-8afc-d5d134e8c785",
//   CLIENT_SECRET: "L5L8Q~IhNY~MBMfVW4TIb.0_WXWd6uF8jF9kPbKo",
//   TENANT_ID: "b12dfebb-2925-4afa-b577-094a6595c3f9",

//   // Dynamic redirect URI that works for both /frontend/home and /frontend/chatbot/{id}
//   // Note: Both URIs must be registered in Azure App Registration
//   get REDIRECT_URI() {
//     return getRedirectUri();
//   },

//   // Space-separated scopes for OAuth (included offline_access for refresh token)
//   SCOPES: "Files.Read.All User.Read offline_access",

//   // Use common endpoint to allow both organizational and personal accounts
//   AUTHORITY: "https://login.microsoftonline.com/common/",
//   AUTH_URI: "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
//   TOKEN_URI: "https://login.microsoftonline.com/common/oauth2/v2.0/token",
//   GRAPH_API_BASE: "https://graph.microsoft.com/v1.0",
// };

// export default ONEDRIVE_CONFIG;

export const ONEDRIVE_CONFIG = {
  APPLICATION_ID: "20f96458-a442-4e5e-8afc-d5d134e8c785",
  CLIENT_SECRET: "L5L8Q~IhNY~MBMfVW4TIb.0_WXWd6uF8jF9kPbKo",
  TENANT_ID: "b12dfebb-2925-4afa-b577-094a6595c3f9",

  // Use localhost for development, production URL for prod
  REDIRECT_URI:
    process.env.NODE_ENV === "production"
      ? "https://securechatai.com/home"
      : "http://localhost:3000/home",

  // Space-separated scopes for OAuth (included offline_access for refresh token)
  SCOPES: "Files.Read.All User.Read offline_access",

  // Use common endpoint to allow both organizational and personal accounts
  AUTHORITY: "https://login.microsoftonline.com/common/",
  AUTH_URI: "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
  TOKEN_URI: "https://login.microsoftonline.com/common/oauth2/v2.0/token",
  GRAPH_API_BASE: "https://graph.microsoft.com/v1.0",
};

export default ONEDRIVE_CONFIG;
